/* PDP refresh (v2). Loaded only when .pdp-v2 is on the product section. */
(function () {
  'use strict';

  function readData(root) {
    var el = root.querySelector('[data-pdp-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariantId(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return '';
    var el = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    return el && el.value && el.value !== 'not-selected' ? String(el.value) : '';
  }

  function mainButton(root) {
    return root.querySelector('.product__information form[action*="/cart/add"] [data-add-to-cart-trigger]');
  }

  /* ---------- Variant-dependent pieces ---------- */
  function sync(root, data) {
    var id = currentVariantId(root);
    if (!id || !data.variants[id]) return;
    if (root.__pdpLastId === id) return;
    root.__pdpLastId = id;
    var v = data.variants[id];

    // Status pill
    var msgs = root.querySelectorAll('[data-pdp-status] [data-pdp-variant]');
    Array.prototype.forEach.call(msgs, function (p) {
      p.hidden = p.getAttribute('data-pdp-variant') !== id;
    });

    // Savings badge
    var save = root.__pdpBadge;
    if (save) {
      save.textContent = v.saveLabel || '';
      save.hidden = !v.saveLabel;
    }

    // Back-in-stock button only for sold-out variants
    root.classList.toggle('pdp-variant-available', !!v.available);
    bisButtons(root, v.available);

    // Free shipping wording
    var ship = root.querySelector('[data-pdp-ship]');
    if (ship) ship.textContent = v.price >= data.shipThreshold ? data.shipOver : data.shipUnder;

    // Sticky bar: variant (truncates) - price (always visible)
    var sv = root.querySelector('[data-pdp-sticky-variant]');
    var sp = root.querySelector('[data-pdp-sticky-price]');
    if (sv) { sv.textContent = v.title || ''; sv.hidden = !v.title; }
    if (sp) sp.textContent = v.priceText;

    // Pre-order button label (runs after the theme resets the label)
    setTimeout(function () { setButtonLabel(root, data, v); }, 80);
  }

  function setButtonLabel(root, data, v) {
    var btn = mainButton(root);
    if (!btn || btn.disabled || !v.available) return;
    var text = btn.querySelector('.text');
    if (!text) return;
    var original = btn.getAttribute('data-label') || text.textContent;
    try { original = JSON.parse(original); } catch (e) {}
    text.textContent = v.status === 'pre-order' ? data.preorderButton : original;
    var sticky = root.querySelector('[data-pdp-sticky-btn]');
    if (sticky) sticky.textContent = text.textContent;
  }

  function watchVariant(root, data) {
    var run = function () { setTimeout(function () { sync(root, data); }, 60); };
    root.addEventListener('change', run, true);
    root.addEventListener('click', run, true);
    window.addEventListener('popstate', run);
    var vs = root.querySelector('variant-selection');
    if (vs && window.MutationObserver) {
      new MutationObserver(run).observe(vs, { attributes: true, attributeFilter: ['variant'] });
    }
    root.__pdpLastId = null;
    sync(root, data);
    // Klaviyo can inject its button after load, so check again
    [800, 2500].forEach(function (ms) {
      setTimeout(function () {
        var v = data.variants[currentVariantId(root)];
        if (v) bisButtons(root, v.available);
      }, ms);
    });
  }


  /* ---------- Price row: badge beside the price, theme "You save" hidden ---------- */
  function tidyPrice(root) {
    var modal = root.querySelector('.product-block--price .modal_price');
    var badge = root.__pdpBadge;
    if (!modal) return;
    var ui = modal.querySelector('[data-price-ui]');
    if (badge && ui) {
      var anchor = ui.querySelector('.compare-at-price') || ui.querySelector('.price');
      if (anchor && anchor.nextElementSibling !== badge) anchor.insertAdjacentElement('afterend', badge);
    }
    Array.prototype.forEach.call(modal.querySelectorAll('*'), function (el) {
      if (el === badge || el.contains(badge) || el.classList.contains('pdp-hide')) return;
      var t = (el.textContent || '').trim().toLowerCase();
      if (t.indexOf('you save') === 0) el.classList.add('pdp-hide');
    });
  }

  function watchPrice(root) {
    var modal = root.querySelector('.product-block--price .modal_price');
    if (!modal) return;
    var queued = false;
    var run = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tidyPrice(root); });
    };
    if (window.MutationObserver) new MutationObserver(run).observe(modal, { childList: true, subtree: true });
    tidyPrice(root);
  }

  /* ---------- Back-in-stock button (matched by its text as a fallback) ---------- */
  function bisButtons(root, available) {
    var info = root.querySelector('.product__information');
    if (!info) return;
    var els = info.querySelectorAll('button, a, input[type="button"], input[type="submit"]');
    Array.prototype.forEach.call(els, function (el) {
      var t = (el.value || el.textContent || '').trim().toLowerCase();
      if (t.indexOf('notify me') === 0) el.classList.toggle('pdp-bis-hide', !!available);
    });
  }

  /* ---------- Legacy text blocks: grid when every bullet is short ---------- */
  function legacyLists(root) {
    var lists = root.querySelectorAll('.product-block--text ul');
    Array.prototype.forEach.call(lists, function (ul) {
      var items = ul.querySelectorAll('li');
      if (!items.length) return;
      var longest = 0;
      Array.prototype.forEach.call(items, function (li) {
        longest = Math.max(longest, li.textContent.trim().length);
      });
      ul.classList.add('pdp-legacy-list');
      if (longest <= 34) ul.classList.add('is-grid');
      if (longest <= 22) ul.classList.add('is-grid-mobile');
    });
  }

  /* ---------- Sticky add-to-cart (phones), pinned under the header ---------- */
  function headerBottom(bar) {
    // Find whatever is pinned to the top of the screen (sticky header, announcement bar)
    var x = Math.round(window.innerWidth / 2);
    var el = document.elementFromPoint(x, 1);
    var bottom = 0;
    while (el && el !== document.body && el !== document.documentElement) {
      if (el === bar || bar.contains(el)) return 0;
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0) bottom = Math.max(bottom, r.bottom);
      }
      el = el.parentElement;
    }
    return Math.round(bottom);
  }

  function sticky(root) {
    var bar = root.querySelector('[data-pdp-sticky]');
    var btn = mainButton(root);
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 798px)');
    var pastButton = false;
    var ticking = false;

    function place() {
      bar.style.setProperty('--pdp-sticky-top', headerBottom(bar) + 'px');
    }

    function update() {
      var show = mq.matches && pastButton && !btn.disabled;
      if (show) place();
      bar.hidden = !show;
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }).observe(btn);

    // Headers that hide/show on scroll change height, so re-measure while visible
    window.addEventListener('scroll', function () {
      if (bar.hidden || ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; place(); });
    }, { passive: true });

    if (mq.addEventListener) mq.addEventListener('change', update);

    bar.querySelector('[data-pdp-sticky-btn]').addEventListener('click', function () {
      btn.click();
    });
  }

  function init(root) {
    if (!root || root.__pdpInit) return;
    root.__pdpInit = true;
    var data = readData(root);
    root.__pdpBadge = root.querySelector('[data-pdp-save]');
    watchPrice(root);
    legacyLists(root);
    sticky(root);
    if (data) watchVariant(root, data);
  }

    /* ---------- Option help (?) bubbles ---------- */
  function closeHelp(pop) {
    pop.hidden = true;
    var b = document.querySelector('[aria-controls="' + pop.id + '"]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.pdp-help-pop:not([hidden])');
    var btn = e.target.closest && e.target.closest('[data-pdp-help-btn]');
    if (btn) {
      e.preventDefault();
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      var willOpen = pop && pop.hidden;
      Array.prototype.forEach.call(open, closeHelp);
      if (pop && willOpen) {
        pop.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!(e.target.closest && e.target.closest('.pdp-help-pop'))) {
      Array.prototype.forEach.call(open, closeHelp);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Array.prototype.forEach.call(document.querySelectorAll('.pdp-help-pop:not([hidden])'), closeHelp);
    }
  });

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.pdp-v2'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();